import React from 'react'
import { useSelector } from 'react-redux'
import { Box, Typography, Grid, Divider, useTheme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'
import { useHeaderHeight } from 'data/hooks'
import { isEmpty, checkEmpty, imageAddress } from 'data/helpers'
import Title from 'components/Title'
import Buttons from 'pages/Hospitals/Profile/Buttons'
import { useEmployer } from 'data/employer/actions'
import { TextEditor } from 'components/TextEditor/TextEditor'

const useStyles = makeStyles(theme =>
  createStyles({
    header: ({ BackgroundImage }) => ({
      display: 'flex',
      flexDirection: 'row',
      height: '200px',
      justifyContent: 'flex-end',
      width: '100%',
      background: theme.palette.common.white,
      backgroundSize: 'cover',
      backgroundImage: BackgroundImage ? `url(${BackgroundImage})` : undefined,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
    }),
    divider: {
      backgroundColor: theme.palette.success.main,
      width: '100%',
      alignSelf: 'center',
      height: '4px',
      borderRadius: '8px',
      marginBottom: '10px',
    },
  }),
)

export default function HospitalProfile() {
  const theme = useTheme()
  const [{ name, about, image, loading }, getEmployer] = useEmployer()
  const { key, fileName } = checkEmpty(image) ? {} : image
  const BackgroundImage = !checkEmpty(key) ? imageAddress(key, fileName) : undefined
  const classes = useStyles({ headerHeight: useHeaderHeight(175), BackgroundImage })
  const employerUser = useSelector(state => state.employerUser) || {}

  React.useEffect(() => {
    if (employerUser.employerId) {
      getEmployer(employerUser.employerId)
    }
  }, [employerUser.employerId])

  return (
    <>
      {/* Hospital Header */}
      <Box sx={{
        width: '100%',
        backgroundColor: theme.palette.background.dark,
        borderRadius: '0px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
        mb: 4,
        pt: 0,
        pb: { xs: 3, md: 4 },
        px: 0,
      }}>
        <Box sx={{ maxWidth: '91.666667%', mx: 'auto', p: { xs: 2, md: 3 } }}>
          <Grid container spacing={0} sx={{ px: 0 }}>
            <Grid item xs={12} md={8} sx={{ pl: 0 }}>
              <Typography variant='h5' sx={{ 
                color: 'white',
                fontWeight: 'bold',
                mb: 1,
                pl: 0
              }}>
                {name}
              </Typography>
              <Typography variant='caption' sx={{ 
                color: 'rgba(255,255,255,0.7)',
                display: 'block',
                mb: { xs: 2, md: 0 },
                whiteSpace: 'normal',
                wordBreak: 'normal',
                pl: 0
              }}>
                Update your hospital profile here. This will be displayed with each job posting. 
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
      {/* End Hospital Header */}
      <Grid container justifyContent='center' spacing={4}>
        <Grid item xs={12}>
          <Grid container className={classes.header} />
        </Grid>
        <Grid item xs={12} style={{ maxWidth: 800 }}>
          <Grid container style={{ paddingLeft: 16, paddingRight: 16 }} justifyContent='center'>
            <Grid item>
              <Title fullWidth={true} text={name} textAlign='center' marginBottom={24} />
              <Divider variant='middle' className={classes.divider} />
            </Grid>
            <Grid item xs={12}>
              <Typography align='center' variant='body1' inverted='true'>
                {isEmpty(about) ? (
                  'Please update the hospital profile to display about information.'
                ) : (
                  <TextEditor inverted='true' initialValue={about} isReadOnly={true} />
                )}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Box mt={3}>
                <Buttons loading={loading} inverted='true' />
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}
